module.exports = __webpack_public_path__ + "img/sort.059d824a.svg";